import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-opacity": ".9",
      d: "M8.474 11.718a.913.913 0 0 0 0 1.292l3.597 3.597a1 1 0 1 1-1.414 1.414L5.83 13.194a1.174 1.174 0 0 1 0-1.66l4.827-4.827a1 1 0 1 1 1.414 1.414z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-opacity": ".4",
      d: "M14.358 11.834a.75.75 0 0 0 0 1.06l3.713 3.713a1 1 0 1 1-1.414 1.414l-4.975-4.975a.964.964 0 0 1 0-1.364l4.975-4.975a1 1 0 1 1 1.414 1.414z"
    }, null, -1)
  ]))]))
}
export default { render: render }